// seasonRosters.js
// Hardcoded 2026 Season Rosters - these are the permanent draft results

export const SEASON_ROSTERS = {
  'Jedlicka': ['Rory McIlroy', 'Aaron Rai', 'Keegan Bradley', 'Adam Scott', 'Davis Riley', 'Joel Dahmen', 'Beau Hossler'],
  'Moy': ['Ludvig Aberg', 'Bryson DeChambeau', 'Robert MacIntyre', 'Jordan Spieth', 'Michael Kim', 'Michael Thorbjornsen', 'Eric Cole'],
  'Starr': ['Xander Schauffele', 'Brooks Koepka', 'Alex Noren', 'Taylor Pendrith', 'Denny McCarthy', 'Will Zalatoris', 'Ryo Hisatsune'],
  'Drozd': ['Tommy Fleetwood', 'Si Woo Kim', 'Jason Day', 'Sungjae Im', 'J.T. Poston', 'Aldrich Potgieter', 'Cameron Smith'],
  'Ben': ['Harris English', 'Sam Burns', 'Corey Conners', 'Tyrrell Hatton', 'Patrick Reed', 'Stephan Jaeger', 'Thomas Detry'],
  'Chin': ['Justin Rose', 'Ryan Gerard', 'Ben Griffin', 'Ryan Fox', 'Rasmus Hojgaard', 'Max Greyserman', 'Rasmus Neergaard-Petersen'],
  'Stumpf': ['Viktor Hovland', 'Patrick Cantlay', 'Justin Thomas', 'Rickie Fowler', 'Lucas Glover', 'Max Homa', 'Mackenzie Hughes'],
  'Hoffmann': ['Hideki Matsuyama', 'Matt Fitzpatrick', 'Jon Rahm', 'Kurt Kitayama', 'Daniel Berger', 'Nicolai Hojgaard', 'Haotong Li'],
  'Noonan': ['Collin Morikawa', 'Cameron Young', 'Akshay Bhatia', 'Wyndham Clark', 'Sahith Theegala', 'Tony Finau', 'Billy Horschel'],
  'Stack': ['Russell Henley', 'Chris Gotterup', 'Matt McCarty', 'Marco Penge', 'Harry Hall', 'John Keefer', 'Sami Valimaki'],
  "O'Hare": ['J.J. Spaun', 'Maverick McNealy', 'Min Woo Lee', 'Pierceson Coody', 'Tom Hoge', 'Jackson Koivun(Am)', 'Keith Mitchell'],
  'McEldowney': ['Shane Lowry', 'Sepp Straka', 'Brian Harman', 'Andrew Novak', 'Nick Taylor', 'Jake Knapp', 'Kristoffer Reitan'],
};

// Get a flat set of all rostered golfer names
export const getAllRosteredGolferNames = () => {
  const names = new Set();
  Object.values(SEASON_ROSTERS).forEach(roster => {
    roster.forEach(name => names.add(name));
  });
  return names;
};

// Find which participant drafted a golfer
export const getGolferOwner = (golferName) => {
  for (const [participant, roster] of Object.entries(SEASON_ROSTERS)) {
    if (roster.includes(golferName)) return participant;
  }
  return null;
};
